import React from 'react';
import {
  Checkbox,
  Combobox,
  Option,
  Input,
  Textarea,
  Field,
  Label,
  Text,
  MessageBarBody,
  MessageBarTitle,
  Switch,
  InfoLabel,
  RadioGroup,
  Radio
} from '@fluentui/react-components';
import {
  DocumentRegular,
  EyeRegular,
  StethoscopeRegular,
  ReceiptMoneyRegular,
  MoneyRegular,
  ArrowTrendingDownRegular,
  CalendarLtrRegular,
  VideoRegular,
  FlowchartRegular,
  WarningRegular,
  BranchRegular,
  PeopleTeamRegular,
  AddCircleRegular,
  PersonRegular,
  CalculatorRegular,
  WalletRegular,
} from '@fluentui/react-icons';
import { useEffect, useState, useCallback } from 'react';
import { useScrollShadow } from '../../../../commons/functions/useScrollShadow';
import { connect } from 'react-redux';
import { ContractConcept } from '../../../../models/Entities/Contracts/ContractConcept';
import { NewContractConcept } from '../../../../models/Entities/Contracts/NewContractConcept';
import MedicalServiceSelectorComponent from '../../../../commons/component/Inputs/MedicalServiceSelector/MedicalServiceSelectorComponent';
import ProviderSelectorComponent from '../../../../commons/component/Inputs/ProviderSelector/ProviderSelectorComponent';
import ContractConceptSelectorComponent from '../../../../commons/component/Inputs/ContractConceptSelector/ContractConceptSelector.Component';
import { GuideDrawer } from '../../../../theme/components/GuideDrawer';
import { GuideMessageBar } from '../../../../theme/components/GuideMessageBar';
import ContractBranchSelectorComponent from '../../../../commons/component/Inputs/ContractBranchSelector/ContractBranchSelector.Component';
import ServiceCategorySelectorComponent from '../../../../commons/component/Inputs/ServiceCategorySelector/ServiceCategorySelector.Component';
import ContractConceptCategorySelector from '../../../../commons/component/Inputs/ContractConceptCategorySelector/ContractConceptCategorySelector.Component';
import { DateTimeInput } from '../../../../commons/component/Inputs/DateTimeInput/DateTimeInput';
import { ProtocolConceptMultiSelectorComponent } from '../../Protocols/ProtocolContractForm/ProtocolContractConcept/ProtocolConceptMultiSelector/ProtocolConceptMultiselectorComponent';
import { AvailableMedicalService } from '../../../../models/Entities/MedicalServices/AvailableMedicalService';
import { ServiceCategory } from '../../../../models/Entities/ServiceCategory';


// component functions
import * as ComponentFunctions from './ConceptForm.Functions';

////i18Next
import { useTranslation, Trans } from 'react-i18next';

// styles
import './ConceptForm.Styles.css';
import { ContractConceptPaymentSchedule } from '../../../../models/Entities/Contracts/ContractConceptPaymentSchedule';
import { NewContractConceptConcept } from '../../../../models/Entities/Contracts/NewContractConceptConcept';
import { ContractConceptConcept } from '../../../../models/Entities/Contracts/ContractConceptConcept';
import { IValueOriginOption } from './ConceptForm.Functions';
import ContractStageMultiSelectorComponent from '../ContractStageMultiselector/ContractStageMultiSelector.Component';
import { FormSection, ToggleField, NestedFields } from './ConceptForm.Layout';
import { CurrencySelectorComponent } from '../../../../commons/component/Inputs/CurrencySelector/CurrencySelectorComponent';
import { ConceptBranch } from '../../../../models/Entities/Contracts/ConceptBranch';
import { ContractBranch } from '../../../../models/Entities/Contracts/ContractBranch';

interface FormValidation {
  success: boolean;
  errors: string[];
}

export const ConceptFormComponent = (props: ComponentFunctions.Props) => {
  const [t] = useTranslation();

  const [submittedForm, setSubmittedForm] = useState<boolean>(false);
  const [FormValidationStatus, setFormValidationStatus] = useState<
    FormValidation | undefined
  >();

  const [ContractConceptSaved, setContractConceptSaved] = useState<boolean>(false);
  const [savingSchedules, setSavingSchedules] = useState<boolean>(false);

  // new fields
  //applyToRemoteExecution: boolean,
  //applyToInFaceExecution: boolean,
  //haveDivisionFee: boolean,
  //divisionFeeValue: number,

  const [AddedConceptId, setAddedConceptId] = useState<number>();

  // state variables
  const [conceptId, setConceptId] = useState<number>();
  const [conceptName, setConceptName] = useState<string>();
  const [conceptDescription, setConceptDescription] = useState<string>();
  const [isIncludeInVisit, setIsIncludeInVisit] = useState<boolean>(false);
  const [groupWithInTheVisit, setGroupWithInTheVisit] = useState<boolean>(false);
  const [visitConceptRelationship, setVisitConceptRelationship] = useState<string | null>('');
  const [isOptional, setIsOptional] = useState<boolean>(true);
  const [isManagedByCoordinator, setIsManagedByCoordinator] = useState<boolean>(false);
  const [applyToRemoteExecution, setApplyToRemoteExecution] = useState<boolean>(true);
  const [applyToInFaceExecution, setApplyToInFaceExecution] = useState<boolean>(true);
  const [applyToPhoneExecution, setApplyToPhoneExecution] = useState<boolean>(true);
  const [applyToPreScreeningExecution, setApplyToPreScreeningExecution] = useState<boolean>(true);
  const [applyToScreeningExecution, setApplyToScreeningExecution] = useState<boolean>(true);
  const [applyToRandomizationExecution, setApplyToRandomizationExecution] = useState<boolean>(true);
  const [applyToTreatmentExecution, setApplyToTreatmentExecution] = useState<boolean>(true);
  const [applyToFollowUpExecution, setApplyToFollowUpExecution] = useState<boolean>(true);
  const [applyToUnScheduledExecution, setApplyToUnScheduledExecution] = useState<boolean>(true);
  const [applyToEarlyTerminationExecution, setApplyToEarlyTerminationExecution] = useState<boolean>(true);
  const [applyToFailvisitExecution, setApplyToFailvisitExecution] = useState<boolean>(true);
  const [haveDivisionFee, setHaveDivisionFee] = useState<boolean>(false);
  const [divisionFeeValue, setDivisionFeeValue] = useState<number>(0);
  const [isMedicalService, setIsMedicalService] = useState<boolean>(false);
  const [medicalServiceId, setMedicalServiceId] = useState<number>();
  const [settlementSettingOptionSelected, setSettlementSettingOptionSelected] = useState<ComponentFunctions.ISettlementOption | undefined>();
  const [settlementSetting, setSettlementSetting] = useState<number>();
  const [settlementPeriod, setSettlementPeriod] = useState<number>();
  const [valuationTypeOptionSelected, setValuationTypeOptionSelected] = useState<ComponentFunctions.IValueOriginOption | undefined>();
  const [valuationType, setValuationType] = useState<number>(1);
  const [priceValue, setPriceValue] = useState<number>(0);
  const [remoteFixedValue, setRemoteFixedValue] = useState<number>(0);
  const [phoneFixedValue, setPhoneFixedValue] = useState<number>(0);
  const [haveRepetitionPrice, setHaveRepetitionPrice] = useState<boolean>(false);
  const [repetitionPriceValue, setRepetitionPriceValue] = useState<number>();
  const [haveEarlyDiscontinuationPrice, setHaveEarlyDiscontinuationPrice] = useState<boolean>(false);
  const [earlyDiscontinuationPrice, setEarlyDiscontinuationPrice] = useState<number>();
  const [percentageValue, setPercentageValue] = useState<number>();
  const [percetageBaseOptionSelected, setPercetageBaseOptionSelected] = useState<ComponentFunctions.IPercentageOriginOption | undefined>();
  const [percentageBase, setPercentageBase] = useState<number>();
  const [maxCostPrice, setMaxCostPrice] = useState<number>();
  const [priceListOrigin, setPriceListOrigin] = useState<number>();
  const [haveCost, setHaveCost] = useState<boolean>(false);
  const [costSetting, setCostSetting] = useState<number>();
  const [serviceCategory, setServiceCategory] = useState<string[]>([]);
  // Categoría de concepto de contrato; 0 le dice al servidor que la quite, null que la deje como está.
  const [contractConceptCategoryId, setContractConceptCategoryId] = useState<number | null>(null);
  const [costSettingOptionSelected, setCostSettingOptionSelected] = useState<ComponentFunctions.ICostOptions | undefined>();
  const [percentageCostValue, setPercentageCostValue] = useState<number>();
  const [fixedCostValue, setFixedCostValue] = useState<number>();
  const [costPriceListOrigin, setCostPriceListOrigin] = useState<number>();
  const [costProviderId, setCostProviderId] = useState<number>();
  const [amountToIncludePerSettlement, setAmountToIncludePerSettlement] = useState<number>();
  const [excludeParticularPatient, setExcludeParticularPatient] = useState<boolean>(false);
  const [takeOnlyParticularPatient, setTakeOnlyParticularPatient] = useState<boolean>(false);
  const [calculateType, setCalculateType] = useState<number>();
  const [needAggrupation, setNeedAggrupation] = useState<boolean>(false);
  const [aggrupationSegment, setAggrupationSegment] = useState<number>();
  const [quantityToSettle, setQuantityToSettle] = useState<number>(1);
  const [maxQuantityToSettle, setMaxQuantityToSettle] = useState<number>(1);
  const [capToApply, setCapToApply] = useState<number>(0);
  const [haveGenderFilter, setHaveGenderFilter] = useState<boolean>(false);
  const [appliesToMen, setAppliesToMen] = useState<boolean>(true);
  const [appliesToWomen, setAppliesToWomen] = useState<boolean>(true);
  const [appliesToWomenOfFertileAge, setAppliesToWomenOfFertileAge] = useState<boolean>(true);
  const [appliesToWomenOfNonFertileAge, setAppliesToWomenOfNonFertileAge] = useState<boolean>(true);
  const [appliesBetweenAges, setAppliesBetweenAges] = useState<boolean>(false);
  const [appliesAgesFrom, setAppliesAgesFrom] = useState<number>();
  const [appliesAgesTo, setAppliesAgesTo] = useState<number>();
  const [haveOverhead, setHaveOverhead] = useState<boolean>(false);
  const [overheadValue, setOverheadValue] = useState<number>(0);
  const [averageOverheadValue, setAverageOverheadValue] = useState<number>();
  const [ignoreDecimal, setIgnoreDecimal] = useState<boolean>(false);
  const [initialPeriodDate, setInitialPeriodDate] = useState<Date | null | undefined>();
  const [haveRetroactivity, setHaveRetroactivity] = useState<boolean>(false);
  const [retroactivityValue, setRetroactivityValue] = useState<number>();
  const [retroactivityRemoteValue, setRetroactivityRemoteValue] = useState<number>();
  const [retroactivityDateFrom, setRetroactivityDateFrom] = useState<Date | null | undefined>();
  const [haveWithdrawal, setHaveWithdrawal] = useState<boolean>(false);
  const [withdrawalValue, setWithdrawalValue] = useState<number>();
  const [allowInputByMedicalSector, setAllowInputByMedicalSector] = useState<boolean>(true);
  const [incluedInContractConceptId, setIncluedInContractConceptId] = useState<number>(0);
  const [markIsCostOfConcepyt, setMarkIsCostOfConcepyt] = useState<boolean>(false);

  // display string states for decimal inputs (avoids loss of decimal point during typing)
  const [priceValueStr, setPriceValueStr] = useState<string>('0');
  const [remoteFixedValueStr, setRemoteFixedValueStr] = useState<string>('0');
  const [phoneFixedValueStr, setPhoneFixedValueStr] = useState<string>('0');
  const [percentageValueStr, setPercentageValueStr] = useState<string>('');
  const [withdrawalValueStr, setWithdrawalValueStr] = useState<string>('');
  const [divisionFeeValueStr, setDivisionFeeValueStr] = useState<string>('0');
  const [averageOverheadValueStr, setAverageOverheadValueStr] = useState<string>('');
  const [repetitionPriceValueStr, setRepetitionPriceValueStr] = useState<string>('');
  const [earlyDiscontinuationPriceStr, setEarlyDiscontinuationPriceStr] = useState<string>('');
  const [fixedCostValueStr, setFixedCostValueStr] = useState<string>('');
  const [applyWithholdingOnConceptValues, setApplyWithholdingOnConceptValues] = useState<boolean>(false);
  const [applyOnRandomizedPatients, setApplyOnRandomizedPatients] = useState<boolean>(false);
  const [applyEachXItems, setApplyEachXItems] = useState<number>();
  const [conceptPaymentSchedule, setConceptPaymentSchedule] = useState<ContractConceptPaymentSchedule[]>([]);
  const [conceptAssociated, setConceptsAssociated] = useState<NewContractConceptConcept[]>([]);
  const [filterByBranches, setFilterByBranches] = useState<boolean>(false);
  const [branches, setBranches] = useState<ConceptBranch[]>([]);
  const [currency, setCurrency] = useState<string>(props.Contract?.contractCurrency);

  const handleBranchSelection = (selectedBranches: ConceptBranch[]) => {
    setBranches(selectedBranches);
  };

  //load necesary data
  useEffect(() => {
    props.GetContractById(props.ContractId);
  }, []);

  useEffect(() => {
    if (props.Contract) {
      if (props.ContractConceptId) props.GetContractConceptById(props.ContractConceptId);
    }
  }, [props.Contract === undefined]);

  useEffect(() => {
    if (props.Concept) {
      props.GetAllContractConceptConcepts && props.GetAllContractConceptConcepts(props.ContractId, props.ContractAddendumId, props.Concept.id);
      props.GetAllContractsConceptPaymentSchedule && props.GetAllContractsConceptPaymentSchedule(props.ContractId, props.ContractAddendumId, props.Concept.id);
    }
    /* props.Concept?.id is part of the dependencies because the concept reaches
     * the contract tree asynchronously: on mount it is usually still undefined,
     * and keying only on props.ContractConceptId meant these two collections
     * were never requested at all. */
  }, [props.ContractConceptId, props.Concept?.id]);

  /* Content signature of the associations already saved for this concept. */
  const associatedConceptsKey = (props.Concept?.concepts || [])
    .map((conceptConcept: ContractConceptConcept) =>
      conceptConcept.relatedContractConceptId + ':' + (conceptConcept.applyOnlyOnOwnerAmount === true ? '1' : '0'))
    .sort()
    .join(',');

  /* Relationships restricted to the owner share, as the selector expects them. */
  const applyOnlyOnOwnerAmountConceptIds = conceptAssociated
    .filter((conceptConcept: NewContractConceptConcept) => conceptConcept.applyOnlyOnOwnerAmount === true)
    .map((conceptConcept: NewContractConceptConcept) => conceptConcept.relatedContractConceptId);

  /*
   * Seed the associated concepts from what is already stored. Without this the
   * state stays empty until the user touches the selector, so saving an
   * untouched concept used to send an empty collection, and the selection of a
   * previously edited concept stayed behind (the drawer is never unmounted).
   */
  useEffect(() => {
    const currentConcept = props.Concept;
    if (!currentConcept) return;
    setConceptsAssociated((currentConcept.concepts || []).map((conceptConcept: ContractConceptConcept) => ({
      contractConceptId: currentConcept.id,
      relatedContractConceptId: conceptConcept.relatedContractConceptId,
      isSelect: true,
      applyOnlyOnOwnerAmount: conceptConcept.applyOnlyOnOwnerAmount === true
    })));
  }, [props.Concept?.id, associatedConceptsKey]);

  /*
   * Self-healing rehydration.
   *
   * This form reads its concept from Contract.addendums[x].concepts, but
   * GetContractConceptById above only fills the standalone ContractConcept slice,
   * which nothing here reads. Getting the concept into the tree takes three steps
   * — contract, then addendum, then the addendum's concepts — and each reducer
   * silently drops its payload when the previous step has not landed yet.
   *
   * Without these two effects the drawer depends on the caller having won that
   * race, and opens blank whenever it did not, with nothing to retry.
   */
  useEffect(() => {
    // El error de un guardado anterior (por ejemplo, la categoría desde la tarjeta) no es de este formulario.
    if (props.isOpen) props.ResetContractConceptSaveFlags();
    if (props.isOpen && props.ContractId && props.Contract && !props.AddendumLoaded) {
      props.GetContractAddendumsByContractId(props.ContractId);
    }
  }, [props.isOpen, props.ContractId, props.Contract === undefined, props.AddendumLoaded]);

  useEffect(() => {
    const conceptMissingFromTree = props.ContractConceptId !== undefined && props.Concept === undefined;
    if (props.isOpen && props.ContractId && props.ContractAddendumId !== undefined
      && props.AddendumLoaded && conceptMissingFromTree) {
      props.GetAllContractsConceptByAddendum(props.ContractId, props.ContractAddendumId);
    }
  }, [props.isOpen, props.ContractId, props.ContractAddendumId, props.AddendumLoaded, props.ContractConceptId, props.Concept === undefined]);


  // save control
  useEffect(() => {
    console.log('Add useEffect triggered:', {
      submittedForm,
      isAdded: props.isAdded,
      isAdding: props.isAdding,
      ContractConceptId: props.ContractConceptId,
      ConceptsLength: props.Concepts?.length
    });
    if (submittedForm && props.isAdded && !props.isAdding && props.ContractConceptId === undefined) {
      //alert('Concept added successfully');
      var newConcept: ContractConcept | undefined = props.Concepts?.at(-1);
      //alert('New Concept ID: ' + newConcept?.id);
      setAddedConceptId(newConcept?.id);
      //alert('Add concept as saved');
      setContractConceptSaved(true);
      //alert('ValuationType' + valuationType + ' SettlementSetting: ' + settlementSetting);
      if (valuationType !== 5 && settlementSetting !== 4) {
        //alert('Dismissing panel');
        ResetForm();
        props.dismissPanel();
      } else {
        setSavingSchedules(true);
      }
    }
  }, [props.isAdded, props.isAdding]);

  // save control
  useEffect(() => {
    console.log('Update useEffect triggered:', {
      submittedForm,
      isUpdated: props.isUpdated,
      isUpdating: props.isUpdating,
      ContractConceptId: props.ContractConceptId,
      ConceptsLength: props.Concepts?.length
    });
    //alert('ValuationType' + valuationType + ' SettlementSetting: ' + settlementSetting);
    if (submittedForm && props.isUpdated && !props.isUpdating && props.ContractConceptId !== undefined) {
      //alert('Add concept as saved');
      setContractConceptSaved(true);
      if (valuationType !== 5 && settlementSetting !== 4) {
        //alert('dismissing panel');
        ResetForm();
        props.dismissPanel();
      } else {
        setSavingSchedules(true);
      }
    }
  }, [props.isUpdated, props.isUpdating]);

  useEffect(() => {
    if (props.Concept) {
      const newFields = ComponentFunctions.getContractConceptFieldDefaults(props.Concept);

      setConceptId(props.Concept.concept?.id);
      setConceptName(props.Concept.concept?.conceptName);
      setConceptDescription(props.Concept.concept?.conceptDescription);
      setIsIncludeInVisit(props.Concept.isIncludeInVisit);
      setGroupWithInTheVisit(props.Concept.groupWithInTheVisit);
      setVisitConceptRelationship(props.Concept.visitConceptRelationship);
      setIsOptional(props.Concept.isOptional);
      setIsManagedByCoordinator(props.Concept.isManagedByCoordinator);
      setApplyToRemoteExecution(props.Concept.applyToRemoteExecution);
      setApplyToInFaceExecution(props.Concept.applyToInFaceExecution);
      setApplyToPhoneExecution(props.Concept.applyToPhoneExecution);
      setApplyToPreScreeningExecution(props.Concept.applyToPreScreeningExecution);
      setApplyToScreeningExecution(props.Concept.applyToScreeningExecution);
      setApplyToRandomizationExecution(props.Concept.applyToRandomizationExecution);
      setApplyToTreatmentExecution(props.Concept.applyToTreatmentExecution);
      setApplyToFollowUpExecution(props.Concept.applyToFollowUpExecution);
      setApplyToUnScheduledExecution(props.Concept.applyToUnScheduledExecution);
      setApplyToEarlyTerminationExecution(props.Concept.applyToEarlyTerminationExecution);
      setApplyToFailvisitExecution(props.Concept.applyToFailvisitExecution);
      setHaveDivisionFee(props.Concept.haveDivisionFee);
      setDivisionFeeValue(props.Concept.divisionFeeValue);
      setIsMedicalService(props.Concept.isMedicalService);
      setMedicalServiceId(props.Concept.medicalServiceId);
      setSettlementSetting(props.Concept.settlementSetting);
      setSettlementSettingOptionSelected(ComponentFunctions.SettlementOptions.find((option: ComponentFunctions.ISettlementOption) => option.key.toString() === props.Concept.settlementSetting.toString()));
      setSettlementPeriod(props.Concept.settlementPeriod);
      setValuationType(props.Concept.valuationType);
      setValuationTypeOptionSelected(ComponentFunctions.ValueOriginOptions.find((option: ComponentFunctions.IValueOriginOption) => option.key === props.Concept.valuationType.toString()));
      setPriceValue(props.Concept.priceValue || 0);
      setHaveRepetitionPrice(props.Concept.haveRepetitionPrice);
      setRepetitionPriceValue(props.Concept.repetitionPriceValue);
      setHaveEarlyDiscontinuationPrice(props.Concept.haveEarlyDiscontinuationPrice);
      setEarlyDiscontinuationPrice(props.Concept.earlyDiscontinuationPrice);
      setPercentageValue(props.Concept.percentageValue);
      setPercetageBaseOptionSelected(ComponentFunctions.PercentageOriginOptions.find((option: ComponentFunctions.IPercentageOriginOption) => option.key === props.Concept.percentageBase?.toString()) || undefined);
      setMaxCostPrice(props.Concept.maxCostPrice);
      setPriceListOrigin(props.Concept.priceListOrigin);
      setHaveCost(props.Concept.haveCost);
      setCostSettingOptionSelected(ComponentFunctions.ConceptCostOptions.find((option: ComponentFunctions.ICostOptions) => option.key === props.Concept.costSetting?.toString()) || undefined);
      setCostSetting(props.Concept.costSetting);
      setServiceCategory(props.Concept.serviceCategory ? [props.Concept.serviceCategory] : []);
      setContractConceptCategoryId(props.Concept.contractConceptCategoryId ?? null);
      setPercentageCostValue(props.Concept.percentageCostValue);
      setPercentageBase(props.Concept.percentageBase);
      setFixedCostValue(props.Concept.fixedCostValue);
      setCostPriceListOrigin(props.Concept.costPriceListOrigin);
      setCostProviderId(props.Concept.costProviderId);
      setAmountToIncludePerSettlement(props.Concept.amountToIncludePerSettlement);
      setExcludeParticularPatient(props.Concept.excludeParticularPatient);
      setTakeOnlyParticularPatient(props.Concept.takeOnlyParticularPatient);
      setCalculateType(props.Concept.calculateType);
      setNeedAggrupation(props.Concept.needAgrupation);
      setAggrupationSegment(props.Concept.agroupationSegment);
      setQuantityToSettle(props.Concept.quantityToSettle);
      setMaxQuantityToSettle(props.Concept.maxQuantityToSettle);
      setHaveGenderFilter(props.Concept.haveGenderFilter);
      setAppliesToMen(props.Concept.appliesToMen);
      setAppliesToWomen(props.Concept.appliesToWomen);
      setAppliesToWomenOfFertileAge(props.Concept.appliesToWomenOfFertileAge);
      setAppliesToWomenOfNonFertileAge(props.Concept.appliesToWomenOfNonFertileAge);
      setAppliesBetweenAges(props.Concept.appliesToAgeBetween);
      setAppliesAgesFrom(props.Concept.ageFrom);
      setAppliesAgesTo(props.Concept.ageTo);
      setHaveOverhead(props.Concept.haveOverhead);
      setOverheadValue(props.Concept.overheadValue);
      setAverageOverheadValue(props.Concept.averageOverheadValue);
      setIgnoreDecimal(props.Concept.ignoreDecimal);
      // added fields
      setInitialPeriodDate(props.Concept.initialPeriodDate);
      setRemoteFixedValue(props.Concept.remoteFixedValue || 0);
      setPhoneFixedValue(props.Concept.phoneFixedValue || 0);
      setHaveRetroactivity(props.Concept.haveRetroactivity);
      setRetroactivityValue(props.Concept.retroactivityValue);
      setRetroactivityRemoteValue(props.Concept.retroactivityRemoteValue);
      setRetroactivityDateFrom(props.Concept.retroactivityDateFrom);
      setHaveWithdrawal(props.Concept.haveWithdrawal);
      setWithdrawalValue(props.Concept.withdrawalValue);
      setNeedAggrupation(props.Concept.needAgrupation);
      setAggrupationSegment(props.Concept.agroupationSegment);
      setAverageOverheadValue(props.Concept.averageOverheadValue);
      setApplyWithholdingOnConceptValues(props.Concept.applyWithholdingOnConceptValues);
      setApplyOnRandomizedPatients(props.Concept.takeOnlyRandomizedPatients);
      setApplyEachXItems(props.Concept.applyEachXItems);
      setFilterByBranches(props.Concept.filterByBranches);
      setBranches(props.Concept.branches || []);
      setAllowInputByMedicalSector(newFields.allowInputByMedicalSector);
      setIncluedInContractConceptId(newFields.incluedInContractConceptId);
      setMarkIsCostOfConcepyt(newFields.markIsCostOfConcepyt);
      // end added fields
      // sync display string states
      setPriceValueStr((props.Concept.priceValue || 0).toString());
      setRemoteFixedValueStr((props.Concept.remoteFixedValue || 0).toString());
      setPhoneFixedValueStr((props.Concept.phoneFixedValue || 0).toString());
      setPercentageValueStr(props.Concept.percentageValue?.toString() ?? '');
      setWithdrawalValueStr(props.Concept.withdrawalValue?.toString() ?? '');
      setDivisionFeeValueStr(props.Concept.divisionFeeValue?.toString() ?? '0');
      setAverageOverheadValueStr(props.Concept.averageOverheadValue?.toString() ?? '');
      setRepetitionPriceValueStr(props.Concept.repetitionPriceValue?.toString() ?? '');
      setEarlyDiscontinuationPriceStr(props.Concept.earlyDiscontinuationPrice?.toString() ?? '');
      setFixedCostValueStr(props.Concept.fixedCostValue?.toString() ?? '');
    }
  }, [props.ContractConceptId, props.Concept?.id]);

  const ResetForm = () => {
    setConceptName(undefined);
    setConceptDescription(undefined);
    setSubmittedForm(false);
    setFormValidationStatus(undefined);
    setConceptId(undefined);
    setIsIncludeInVisit(false);
    setGroupWithInTheVisit(false);
    setIsOptional(true);
    setIsManagedByCoordinator(false);
    setApplyToRemoteExecution(true);
    setApplyToInFaceExecution(true);
    setApplyToPhoneExecution(true);
    setApplyToPreScreeningExecution(true);
    setApplyToScreeningExecution(true);
    setApplyToRandomizationExecution(true);
    setApplyToTreatmentExecution(true);
    setApplyToFollowUpExecution(true);
    setApplyToUnScheduledExecution(true);
    setApplyToEarlyTerminationExecution(true);
    setApplyToFailvisitExecution(true);
    setHaveDivisionFee(false);
    setDivisionFeeValue(0);
    setIsMedicalService(false);
    setMedicalServiceId(undefined);
    setSettlementSetting(undefined);
    setSettlementSettingOptionSelected(undefined);
    setSettlementPeriod(undefined);
    setValuationType(1);
    setValuationTypeOptionSelected(undefined);
    setPriceValue(0);
    setHaveRepetitionPrice(false);
    setRepetitionPriceValue(undefined);
    setHaveEarlyDiscontinuationPrice(false);
    setEarlyDiscontinuationPrice(undefined);
    setPercentageValue(undefined);
    setPercetageBaseOptionSelected(undefined);
    setPercentageBase(undefined);
    setMaxCostPrice(undefined);
    setPriceListOrigin(undefined);
    setHaveCost(false);
    setCostSetting(undefined);
    setCostSettingOptionSelected(undefined);
    setServiceCategory([]);
    setContractConceptCategoryId(null);
    setPercentageCostValue(undefined);
    setFixedCostValue(undefined);
    setCostPriceListOrigin(undefined);
    setCostProviderId(undefined);
    setAmountToIncludePerSettlement(undefined);
    setExcludeParticularPatient(false);
    setTakeOnlyParticularPatient(false);
    setCalculateType(undefined);
    setNeedAggrupation(false);
    setAggrupationSegment(undefined);
    setQuantityToSettle(1);
    setMaxQuantityToSettle(1);
    setHaveGenderFilter(false);
    setAppliesToMen(true);
    setAppliesToWomen(true);
    setAppliesToWomenOfFertileAge(true);
    setAppliesToWomenOfNonFertileAge(true);
    setAppliesBetweenAges(false);
    setAppliesAgesFrom(undefined);
    setAppliesAgesTo(undefined);
    setHaveOverhead(false);
    setOverheadValue(0);
    setAverageOverheadValue(undefined);
    setIgnoreDecimal(false);
    setInitialPeriodDate(undefined);
    setRemoteFixedValue(0);
    setPhoneFixedValue(0);
    setHaveRetroactivity(false);
    setRetroactivityValue(undefined);
    setRetroactivityRemoteValue(undefined);
    setRetroactivityDateFrom(undefined);
    setHaveWithdrawal(false);
    setWithdrawalValue(undefined);
    setVisitConceptRelationship('');
    setPhoneFixedValue(0);
    setServiceCategory([]);
    setContractConceptCategoryId(null);
    setApplyWithholdingOnConceptValues(false);
    setApplyOnRandomizedPatients(false);
    setApplyEachXItems(undefined);
    setAllowInputByMedicalSector(true);
    setIncluedInContractConceptId(0);
    setMarkIsCostOfConcepyt(false);
    setContractConceptSaved(false);
    setSavingSchedules(false);
    setAddedConceptId(undefined);
    setCapToApply(0);
    setFilterByBranches(false);
    setBranches([]);
    // reset display string states
    setPriceValueStr('0');
    setRemoteFixedValueStr('0');
    setPhoneFixedValueStr('0');
    setPercentageValueStr('');
    setWithdrawalValueStr('');
    setDivisionFeeValueStr('0');
    setAverageOverheadValueStr('');
    setRepetitionPriceValueStr('');
    setEarlyDiscontinuationPriceStr('');
    setFixedCostValueStr('');
    setConceptsAssociated([]);
  };

  const onFinishedSavingHandler = useCallback((status: boolean) => {
    if (status && ContractConceptSaved) {
      setSavingSchedules(false);
      ResetForm();
      props.dismissPanel();
    }
  }, [ContractConceptSaved, props.dismissPanel]);

  const onChangeValuationTypeSelection = (
    event: React.FormEvent<HTMLDivElement>,
    item?: IValueOriginOption
  ) => {
    setValuationTypeOptionSelected(item);
    setValuationType(Number(item?.key));
  }

  const onChangeMedicalServiceIdSelection = (
    medicalservice?: AvailableMedicalService | undefined
  ) => {
    setMedicalServiceId(medicalservice?.id);
  }

  const onChangePriceTextFieldValue = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setPriceValue(Number(newValue));
  }

  const onChangePercentageTextFieldValue = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setPercentageValue(Number(newValue));
  }

  const onChangeMaxCostPriceTextFieldValue = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setMaxCostPrice(Number(newValue));
  }

  // -----------------------------------------------------

  const onChangeConceptSelection = (
    concepts: ContractConcept[]
  ) => {
    /*
     * Rebuilt from the previous state so the per relationship configuration
     * survives a plain check or uncheck, and so a concept that is no longer
     * associated does not carry its configuration to the server.
     */
    setConceptsAssociated((previousConceptAssociated: NewContractConceptConcept[]) =>
      (concepts || []).map((concept: ContractConcept) => ({
        contractConceptId: props.Concept?.id!,
        relatedContractConceptId: concept.id,
        isSelect: concept.isSelected,
        applyOnlyOnOwnerAmount: concept.isSelected && previousConceptAssociated.some(
          (conceptConcept: NewContractConceptConcept) =>
            conceptConcept.relatedContractConceptId === concept.id && conceptConcept.applyOnlyOnOwnerAmount === true
        )
      }))
    );
  };

  const onChangeApplyOnlyOnOwnerAmount = (
    applyOnlyOnOwnerAmount: boolean,
    conceptId: number
  ) => {
    setConceptsAssociated((previousConceptAssociated: NewContractConceptConcept[]) => {
      const isAlreadyAssociated = previousConceptAssociated.some(
        (conceptConcept: NewContractConceptConcept) => conceptConcept.relatedContractConceptId === conceptId
      );

      /* The selector can configure a concept the user has just checked, before
       * the selection change reached this state. */
      if (!isAlreadyAssociated) {
        return [...previousConceptAssociated, {
          contractConceptId: props.Concept?.id!,
          relatedContractConceptId: conceptId,
          isSelect: true,
          applyOnlyOnOwnerAmount: applyOnlyOnOwnerAmount
        }];
      }

      return previousConceptAssociated.map((conceptConcept: NewContractConceptConcept) =>
        conceptConcept.relatedContractConceptId === conceptId
          ? { ...conceptConcept, applyOnlyOnOwnerAmount: applyOnlyOnOwnerAmount }
          : conceptConcept
      );
    });
  };

  const onAddConceptToConcept = (concept: ContractConcept) => {
    //alert('agrega concepto' + concept.id);
    // // get if concept is already associated
    // var auxConcept = props.Concept?.concepts?.find(concept => 
    //   concept.relatedContractConceptId === concept.id
    // );

    // if (!auxConcept) {
    //   setConceptsAssociated([...conceptAssociated, {
    //     contractConceptId: props.Concept.id,
    //     relatedContractConceptId: concept.id
    //   }]);
    // } else {
    //   setConceptsAssociated([...conceptAssociated, auxConcept]);
    // }
  }

  const onRemoveConceptFromConcept = (concept: ContractConcept) => {
    // alert('quita concepto' + concept.id);
    // // console.log('conceptos asociados', conceptAssociated);
    // setConceptsAssociated(conceptAssociated?.filter(conceptAssociated => conceptAssociated?.relatedContractConceptId !== concept.id));
  }

  // const onChangeHaveCost = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveCost(checked || false);
  // }

  // const onChangeCostSetting = (
  //   event: React.FormEvent<HTMLDivElement>,
  //   option?: ComponentFunctions.ICostOptions
  // ) => {
  //   setCostSettingOptionSelected(option);
  //   setCostSetting(Number(option?.key) || undefined);
  // }

  // const onChangeFixedCostTextFieldValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setFixedCostValue(Number(newValue));
  // }

  // const onChangePercentageCostTextFieldValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setPercentageCostValue(Number(newValue));
  // }

  // const onChangeHaveEarlyDiscontinuationPrice = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveEarlyDiscontinuationPrice(checked || false);
  // };

  // const onChangeEarlyDiscontinuationPriceTextFieldValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setEarlyDiscontinuationPrice(Number(newValue));
  // }

  // const onChangeAgroupationTag = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setNeedAggrupation(checked || false);
  // }

  // const onChangeAgroupationSegment = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setAggrupationSegment(Number(newValue));
  // }

  // const onChangePaymentSchedule = (
  //   paymentSchedule: ContractConceptPaymentSchedule[]
  // ) => {
  //   console.log(paymentSchedule);
  //   setConceptPaymentSchedule(paymentSchedule);
  // };


  // const onChangeQuantityToSettle = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setQuantityToSettle(Number(newValue));
  // }

  // const onChangeAmountToIncludePerSettlement = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setAmountToIncludePerSettlement(Number(newValue));
  // }

  // const onChangeExcludeParticularPatient = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setExcludeParticularPatient(checked || false);
  // }

  // const onChangeTakeOnlyParticularPatient = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setTakeOnlyParticularPatient(checked || false);
  // }

  // const onChangeMaxQuantityToSettle = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setMaxQuantityToSettle(Number(newValue));
  // }

  // const onChangeHaveGenderFilter = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveGenderFilter(checked || false);
  // }

  // const onChangeAppliesBetweenAges = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesBetweenAges(checked || false);
  // }

  // const onChangeAppliesToMen = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesToMen(checked || false);
  // }

  // const onChangeAppliesToWomen = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesToWomen(checked || false);
  // }

  // const onChangeAppliesToWomenOfFertileAge = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesToWomenOfFertileAge(checked || false);
  // }

  // const onChangeAppliesToWomenOfNonFertileAge = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesToWomenOfNonFertileAge(checked || false);
  // }

  // const onChangeHaveOverhead = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveOverhead(checked || false);
  // }

  // const onChangeOverheadValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setOverheadValue(Number(newValue));
  // }

  // const onChangeAvergaveOverheadValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setAverageOverheadValue(Number(newValue));
  //   // var auxPriceWithoutOverheadValue = priceValue && ((priceValue * 100) / (100 + avergaveOverheadValue)) || 0;
  //   // priceValue && setOverheadValue(priceValue - auxPriceWithoutOverheadValue);
  // }

  // // withdrawal fields

  // const onChangeHaveWithdrawal = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveWithdrawal(checked || false);
  // }

  // const onChangeWithdrawalValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setWithdrawalValue(Number(newValue));
  // }

  // const onChangeApplyToRemoteExecution = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setApplyToRemoteExecution(checked || false);
  // }

  // const onChangeApplyToInFaceExecution = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setApplyToInFaceExecution(checked || false);
  // }

  // const onChangeHaveDivisionFee = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveDivisionFee(checked || false);
  // }

  // const onChangeDivisionFeeValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setDivisionFeeValue(Number(newValue));
  // }

  // // retroactivity fields
  // const onChangeHaveRetroactivity = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveRetroactivity(checked || false);
  // }

  // const onChangeRetroactivityValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setRetroactivityValue(Number(newValue));
  // }

  // handler Actions
  const HandleSaveForm = () => {
    console.log('HandleSaveForm called', {
      conceptName,
      conceptDescription,
      ContractConceptId: props.ContractConceptId,
      serviceCategory: serviceCategory,
      serviceCategoryValue: serviceCategory && serviceCategory.length > 0 ? serviceCategory[0] : undefined
    });
    setContractConceptSaved(false);
    setSubmittedForm(true);
    if (ValidateForm()) {
      let CurrentValues: ContractConcept | NewContractConcept;
      if (props.ContractConceptId) {
        CurrentValues = {
          id: props.ContractConceptId!,
          isSelected: props.Concept?.isSelected ?? false,
          isUnselected: props.Concept?.isUnselected ?? false,
          // owned by the enable/approve endpoints, not by this form: carried through untouched
          contractConceptEnabled: props.Concept?.contractConceptEnabled ?? true,
          contractConceptApproved: props.Concept?.contractConceptApproved ?? false,
          contractId: props.ContractId,
          contractAddendumId: props.ContractAddendumId,
          conceptId: conceptId!,
          concept: {
            id: conceptId!,
            conceptName: conceptName!,
            conceptDescription: conceptDescription!,
            conceptReferenceId: '1'
          },
          conceptCurrency: currency!,
          isIncludeInVisit: isIncludeInVisit,
          groupWithInTheVisit: groupWithInTheVisit ?? false,
          visitConceptRelationship: visitConceptRelationship,
          isOptional: isOptional,
          isManagedByCoordinator: isManagedByCoordinator,
          applyToRemoteExecution: applyToRemoteExecution,
          applyToInFaceExecution: applyToInFaceExecution,
          applyToPhoneExecution: applyToPhoneExecution,
          applyToPreScreeningExecution: applyToPreScreeningExecution,
          applyToScreeningExecution: applyToScreeningExecution,
          applyToRandomizationExecution: applyToRandomizationExecution,
          applyToTreatmentExecution: applyToTreatmentExecution,
          applyToFollowUpExecution: applyToFollowUpExecution,
          applyToUnScheduledExecution: applyToUnScheduledExecution,
          applyToEarlyTerminationExecution: applyToEarlyTerminationExecution,
          haveDivisionFee: haveDivisionFee,
          divisionFeeValue: divisionFeeValue!,
          isMedicalService: isMedicalService!,
          medicalServiceId: medicalServiceId!,
          settlementSetting: settlementSetting!,
          settlementPeriod: settlementPeriod!,
          valuationType: valuationType!,
          priceValue: priceValue!,
          phoneFixedValue: phoneFixedValue,
          remoteFixedValue: remoteFixedValue,
          haveRepetitionPrice: haveRepetitionPrice!,
          repetitionPriceValue: repetitionPriceValue!,
          haveEarlyDiscontinuationPrice: haveEarlyDiscontinuationPrice!,
          earlyDiscontinuationPrice: earlyDiscontinuationPrice!,
          percentageValue: percentageValue!,
          maxCostPrice: maxCostPrice!,
          priceListOrigin: priceListOrigin!,
          haveCost: haveCost!,
          costSetting: costSetting!,
          serviceCategory: serviceCategory && serviceCategory.length > 0 ? serviceCategory[0] : undefined,
          contractConceptCategoryId: contractConceptCategoryId,
          percentageCostValue: percentageCostValue!,
          percentageBase: percentageBase!,
          fixedCostValue: fixedCostValue!,
          costPriceListOrigin: costPriceListOrigin!,
          costProviderId: costProviderId!,
          amountToIncludePerSettlement: amountToIncludePerSettlement!,
          excludeParticularPatient: excludeParticularPatient!,
          takeOnlyParticularPatient: takeOnlyParticularPatient!,
          calculateType: calculateType!,
          needAgrupation: needAggrupation!,
          agroupationSegment: aggrupationSegment!,
          quantityToSettle: quantityToSettle!,
          maxQuantityToSettle: maxQuantityToSettle!,
          haveGenderFilter: haveGenderFilter!,
          appliesToMen: appliesToMen!,
          appliesToWomen: appliesToWomen!,
          appliesToWomenOfFertileAge: appliesToWomenOfFertileAge!,
          appliesToWomenOfNonFertileAge: appliesToWomenOfNonFertileAge!,
          appliesToAgeBetween: appliesBetweenAges,
          ageFrom: appliesAgesFrom,
          ageTo: appliesAgesTo,
          haveOverhead: haveOverhead,
          overheadValue: overheadValue,
          averageOverheadValue: averageOverheadValue,
          ignoreDecimal: ignoreDecimal,
          // added fileds
          initialPeriodDate: initialPeriodDate,
          haveRetroactivity: haveRetroactivity,
          retroactivityValue: retroactivityValue,
          retroactivityRemoteValue: retroactivityRemoteValue,
          retroactivityDateFrom: retroactivityDateFrom,
          haveWithdrawal: haveWithdrawal,
          withdrawalValue: withdrawalValue,
          filterByBranches: filterByBranches,
          takeOnlyRandomizedPatients: applyOnRandomizedPatients,
          applyEachXItems: applyEachXItems,
          capToApply: capToApply,
          applyToFailvisitExecution: applyToFailvisitExecution,
          branches: branches || [],
          applyWithholdingOnConceptValues: applyWithholdingOnConceptValues,
          allowInputByMedicalSector: allowInputByMedicalSector,
          incluedInContractConceptId: ComponentFunctions.normalizeIncludedInContractConceptId(incluedInContractConceptId),
          markIsCostOfConcepyt: markIsCostOfConcepyt,

          // end added fields
          concepts: conceptAssociated || [],
          paymentSchedule: conceptPaymentSchedule?.map((schedule: ContractConceptPaymentSchedule) => {
            return {
              id: schedule.id,
              stage: schedule.stage,
              isSelected: schedule.isSelected,
              isUnselected: schedule.isUnselected,
              contractConceptId: props.ContractConceptId!,
              contractStageId: schedule.contractStageId,
              amountExpected: schedule.amountExpected,
              screeningFailurePrice: schedule.screeningFailurePrice,
              settlementCoefficient: schedule.settlementCoefficient,
              price: schedule.price,
              remotePrice: schedule.remotePrice,
              phonePrice: schedule.phonePrice,
              currency: currency!,
              followUpPrice: schedule.followUpPrice,
              settlementRemoteCoefficient: schedule.settlementRemoteCoefficient,
              settlementPhoneCoefficient: schedule.settlementPhoneCoefficient,
              settlementFollowUpCoefficient: schedule.settlementFollowUpCoefficient,
              settlementScreeningFailureCoefficient: schedule.settlementScreeningFailureCoefficient,
              priceWithoutOverhead: schedule.priceWithoutOverhead
            }
          }) || []
        };
        props.UpdateContractConcept(CurrentValues as ContractConcept);
      } else {
        CurrentValues = {
          contractConceptEnabled: true,
          contractConceptApproved: false,
          contractId: props.ContractId,
          contractAddendumId: props.ContractAddendumId,
          conceptId: conceptId!,
          concept: {
            id: conceptId!,
            conceptName: conceptName!,
            conceptDescription: conceptDescription!,
            conceptReferenceId: '1'
          },
          conceptCurrency: currency!,
          isIncludeInVisit: isIncludeInVisit,
          groupWithInTheVisit: groupWithInTheVisit ?? false,
          isOptional: isOptional,
          isManagedByCoordinator: isManagedByCoordinator,
          applyToRemoteExecution: applyToRemoteExecution,
          applyToInFaceExecution: applyToInFaceExecution,
          applyToPhoneExecution: applyToPhoneExecution,
          applyToPreScreeningExecution: applyToPreScreeningExecution,
          applyToScreeningExecution: applyToScreeningExecution,
          applyToRandomizationExecution: applyToRandomizationExecution,
          applyToTreatmentExecution: applyToTreatmentExecution,
          applyToFollowUpExecution: applyToFollowUpExecution,
          applyToUnScheduledExecution: applyToUnScheduledExecution,
          applyToEarlyTerminationExecution: applyToEarlyTerminationExecution,
          applyToFailvisitExecution: applyToFailvisitExecution,
          haveDivisionFee: haveDivisionFee,
          divisionFeeValue: divisionFeeValue!,
          isMedicalService: isMedicalService!,
          medicalServiceId: medicalServiceId!,
          settlementSetting: settlementSetting!,
          settlementPeriod: settlementPeriod!,
          valuationType: valuationType!,
          priceValue: priceValue!,
          phoneFixedValue: phoneFixedValue,
          remoteFixedValue: remoteFixedValue,
          haveRepetitionPrice: haveRepetitionPrice!,
          repetitionPriceValue: repetitionPriceValue!,
          haveEarlyDiscontinuationPrice: haveEarlyDiscontinuationPrice!,
          earlyDiscontinuationPrice: earlyDiscontinuationPrice!,
          percentageValue: percentageValue!,
          percentageBase: percentageBase!,
          maxCostPrice: maxCostPrice!,
          priceListOrigin: priceListOrigin!,
          haveCost: haveCost!,
          costSetting: costSetting!,
          serviceCategory: serviceCategory && serviceCategory.length > 0 ? serviceCategory[0] : undefined,
          contractConceptCategoryId: contractConceptCategoryId,
          percentageCostValue: percentageCostValue!,
          fixedCostValue: fixedCostValue!,
          costPriceListOrigin: costPriceListOrigin!,
          costProviderId: costProviderId!,
          amountToIncludePerSettlement: amountToIncludePerSettlement!,
          excludeParticularPatient: excludeParticularPatient!,
          takeOnlyParticularPatient: takeOnlyParticularPatient!,
          calculateType: calculateType!,
          needAgrupation: needAggrupation!,
          agroupationSegment: aggrupationSegment!,
          quantityToSettle: quantityToSettle!,
          maxQuantityToSettle: maxQuantityToSettle!,
          capToApply: capToApply,
          takeOnlyRandomizedPatients: applyOnRandomizedPatients,
          applyEachXItems: applyEachXItems,
          haveGenderFilter: haveGenderFilter!,
          appliesToMen: appliesToMen!,
          appliesToWomen: appliesToWomen!,
          appliesToWomenOfFertileAge: appliesToWomenOfFertileAge!,
          appliesToWomenOfNonFertileAge: appliesToWomenOfNonFertileAge!,
          appliesToAgeBetween: appliesBetweenAges,
          ageFrom: appliesAgesFrom,
          ageTo: appliesAgesTo,
          haveOverhead: haveOverhead,
          overheadValue: overheadValue,
          averageOverheadValue: averageOverheadValue,
          ignoreDecimal: ignoreDecimal,
          // added fields
          initialPeriodDate: initialPeriodDate,
          haveRetroactivity: haveRetroactivity,
          retroactivityValue: retroactivityValue,
          retroactivityRemoteValue: retroactivityRemoteValue,
          retroactivityDateFrom: retroactivityDateFrom,
          haveWithdrawal: haveWithdrawal,
          withdrawalValue: withdrawalValue,
          filterByBranches: filterByBranches,
          branches: branches || [],
          visitConceptRelationship: visitConceptRelationship,
          applyWithholdingOnConceptValues: applyWithholdingOnConceptValues,
          allowInputByMedicalSector: allowInputByMedicalSector,
          incluedInContractConceptId: ComponentFunctions.normalizeIncludedInContractConceptId(incluedInContractConceptId),
          markIsCostOfConcepyt: markIsCostOfConcepyt,

          // end added fields
          concepts: conceptAssociated || [],
          paymentSchedule: conceptPaymentSchedule?.map((schedule: ContractConceptPaymentSchedule) => {
            return {
              id: schedule.id,
              stage: schedule.stage,
              isSelected: schedule.isSelected,
              isUnselected: schedule.isUnselected,
              contractConceptId: props.ContractConceptId!,
              contractStageId: schedule.contractStageId,
              amountExpected: schedule.amountExpected,
              screeningFailurePrice: schedule.screeningFailurePrice,
              settlementCoefficient: schedule.settlementCoefficient,
              price: schedule.price,
              remotePrice: schedule.remotePrice,
              phonePrice: schedule.phonePrice,
              currency: currency!,
              followUpPrice: schedule.followUpPrice,
              settlementRemoteCoefficient: schedule.settlementRemoteCoefficient,
              settlementPhoneCoefficient: schedule.settlementPhoneCoefficient,
              settlementFollowUpCoefficient: schedule.settlementFollowUpCoefficient,
              settlementScreeningFailureCoefficient: schedule.settlementScreeningFailureCoefficient,
              priceWithoutOverhead: schedule.priceWithoutOverhead
            }
          }) || []
        }
        props.AddContractConcept(props.ContractAddendumId, CurrentValues as NewContractConcept);
      }
    }
  };

  const HandleCancelForm = () => {
    ResetForm();
    props.dismissPanel();
  };

  const leftScroll = useScrollShadow();
  const rightScroll = useScrollShadow();

  const formFields = (
    <div className='flowcharSelector'>
      <div
        ref={leftScroll.ref}
        className={`ScrollShadow${leftScroll.showTop ? ' shadow-top' : ''}${leftScroll.showBottom ? ' shadow-bottom' : ''}`}
        onScroll={leftScroll.onScroll}
      >
        <FormSection
          title={t('conceptForm.formFields.sectionIdentification')}
          description={t('conceptForm.formFields.sectionIdentificationHint')}
          icon={<DocumentRegular fontSize={18} />}
        >
          <Field label={t('conceptForm.formFields.conceptName')}>
            <Input
              value={conceptName || ''}
              onChange={(ev, data) => setConceptName(data.value)}
            />
          </Field>
          <Field label={t('conceptForm.formFields.description')}>
            <Textarea
              rows={3}
              value={conceptDescription || ''}
              onChange={(ev, data) => setConceptDescription(data.value)}
            />
          </Field>
          <ContractConceptCategorySelector
            label={t('conceptItem.category.label', 'Categoría')}
            hint={t('conceptItem.category.hintNew', 'Agrupa el concepto en filtros y resúmenes.')}
            showManageButton
            SelectedCategories={contractConceptCategoryId && contractConceptCategoryId > 0 ? [contractConceptCategoryId] : []}
            onSelectedCategories={(categories) => setContractConceptCategoryId(categories[0]?.id ?? 0)}
          />
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.conceptVisibilitySettingsTitle')}
          description={t('conceptForm.formFields.conceptVisibilitySettingsHint')}
          icon={<EyeRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.isManagedByCoordinator')}
            description={t('conceptForm.formFields.isManagedByCoordinatorHint')}
            checked={isManagedByCoordinator}
            onChange={setIsManagedByCoordinator}
          />
          <ToggleField
            label={t('conceptForm.formFields.allowInputByMedicalSector')}
            description={t('conceptForm.formFields.allowInputByMedicalSectorHint')}
            checked={allowInputByMedicalSector}
            onChange={setAllowInputByMedicalSector}
          />
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionMedicalService')}
          icon={<StethoscopeRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.joinMedicalService')}
            description={t('conceptForm.formFields.joinMedicalServiceHint')}
            checked={isMedicalService}
            onChange={setIsMedicalService}
          >
            <MedicalServiceSelectorComponent
              onSelectedServices={(services: AvailableMedicalService[] | undefined) => onChangeMedicalServiceIdSelection(services?.[0])}
              MedicalServicesSelectedIds={medicalServiceId ? [medicalServiceId] : []}
              MultiselectEnable={false}
            />
          </ToggleField>
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionSettlement')}
          description={t('conceptForm.formFields.sectionSettlementHint')}
          icon={<ReceiptMoneyRegular fontSize={18} />}
        >
          <Field label={t('conceptForm.formFields.settlement')}>
            <Combobox
              value={settlementSettingOptionSelected ? t(settlementSettingOptionSelected.text) : ''}
              selectedOptions={settlementSetting ? [settlementSetting.toString()] : []}
              onOptionSelect={(event, data) => {
                const selectedKey = data.optionValue;
                const selectedOption = ComponentFunctions.SettlementOptions.find(opt => opt.key.toString() === selectedKey);
                setSettlementSettingOptionSelected(selectedOption);
                setSettlementSetting(Number(selectedKey) || undefined);
              }}
            >
              {ComponentFunctions.SettlementOptions.map((option: ComponentFunctions.ISettlementOption) => (
                <Option key={option.key} value={option.key.toString()} text={t(option.text) || ''}>
                  {t(option.text)}
                </Option>
              ))}
            </Combobox>
          </Field>
          {settlementSetting === 7 && (
            <NestedFields>
              <ToggleField
                label={'Aplicar solo a pacientes randomizados'}
                checked={applyOnRandomizedPatients}
                onChange={(checked) => {
                  setApplyOnRandomizedPatients(checked);
                  if (!checked) {
                    setApplyEachXItems(undefined);
                  }
                }}
              >
                <Field label={'Aplicar cada X ítems'}>
                  <Input
                    type="number"
                    min={1}
                    value={applyEachXItems?.toString() || ''}
                    onFocus={(e) => e.target.select()}
                    onChange={(ev, data) => {
                      const value = data.value ? Number.parseInt(data.value, 10) : undefined;
                      setApplyEachXItems(value);
                    }}
                  />
                </Field>
              </ToggleField>
            </NestedFields>
          )}
          {settlementSetting === 5 && (
            <NestedFields>
              <Field label={t('conceptForm.formFields.settlementPeriod')}>
                <Combobox
                  value={settlementPeriod ? t(ComponentFunctions.PeriodOptions.find(opt => opt.key.toString() === settlementPeriod.toString())?.text || '') : ''}
                  selectedOptions={settlementPeriod ? [settlementPeriod.toString()] : []}
                  onOptionSelect={(event, data) => {
                    setSettlementPeriod(Number(data.optionValue) || undefined);
                  }}
                >
                  {ComponentFunctions.PeriodOptions.map((option) => (
                    <Option key={option.key} value={option.key.toString()} text={t(option.text) || ''}>
                      {t(option.text)}
                    </Option>
                  ))}
                </Combobox>
              </Field>
              <DateTimeInput
                label={'Fecha desde que se contabiliza el período'}
                placeHolder={'ingrese una fecha'}
                selectedDate={initialPeriodDate ? new Date(initialPeriodDate) : new Date()}
                isSubmitted={false}
                isRequired={settlementSetting === 5}
                errorMessage={undefined}
                onSelectDate={(date: Date | null | undefined) => setInitialPeriodDate(date)}
              />
            </NestedFields>
          )}
          {settlementSetting === 10 && (
            <NestedFields>
              <ProtocolConceptMultiSelectorComponent
                concepts={props.Concepts || []}
                parentConceptId={props.Concept?.id}
                showPercentage={false}
                onAddConcept={onAddConceptToConcept}
                onDeleteConcept={onRemoveConceptFromConcept}
                onChangeConceptSelection={onChangeConceptSelection}
                onChangeApplyOnlyOnOwnerAmount={onChangeApplyOnlyOnOwnerAmount}
                selectedConceptIds={props.Concepts?.filter(concept => concept.isSelected)?.map(concept => concept.id) || []}
                applyOnlyOnOwnerAmountConceptIds={applyOnlyOnOwnerAmountConceptIds}
              />
            </NestedFields>
          )}
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionValuation')}
          description={t('conceptForm.formFields.sectionValuationHint')}
          icon={<MoneyRegular fontSize={18} />}
        >
          <Field label={t('conceptForm.formFields.valorization')}>
            <Combobox
              value={valuationTypeOptionSelected ? t(valuationTypeOptionSelected.text) : ''}
              selectedOptions={valuationType !== undefined ? [valuationType.toString()] : []}
              onOptionSelect={(event, data) => {
                const selectedKey = data.optionValue;
                const selectedOption = ComponentFunctions.ValueOriginOptions.find(opt => opt.key === selectedKey);
                setValuationTypeOptionSelected(selectedOption);
                setValuationType(Number(selectedKey));
              }}
            >
              {ComponentFunctions.ValueOriginOptions.map((option: ComponentFunctions.IValueOriginOption) => (
                <Option key={option.key} value={option.key.toString()} text={t(option.text) || ''}>
                  {t(option.text)}
                </Option>
              ))}
            </Combobox>
          </Field>
          {!props.Contract?.contractCurrency && (
            <GuideMessageBar intent="warning">
              <MessageBarBody>{t('conceptForm.formFields.message')}</MessageBarBody>
            </GuideMessageBar>
          )}
          {(valuationTypeOptionSelected && (valuationTypeOptionSelected.key === '1' || valuationTypeOptionSelected.key === '2' || valuationTypeOptionSelected.key === '5')) && (
            <CurrencySelectorComponent
              defaultSelected={currency}
              onCurrencyChange={(currency) => setCurrency(currency)}
              errorMessage={undefined}
              label={"Moneda del concepto"} />
          )}
          {(valuationTypeOptionSelected && valuationTypeOptionSelected.key === '1') && (
            <NestedFields>
              <Field label={t('conceptForm.formFields.value')}>
                <Input
                  type="text"
                  inputMode="decimal"
                  contentAfter={currency}
                  value={priceValueStr}
                  onFocus={(e) => e.target.select()}
                  onChange={(ev, data) => {
                    setPriceValueStr(data.value);
                    const parsed = Number.parseFloat(data.value);
                    if (!Number.isNaN(parsed)) setPriceValue(parsed);
                  }}
                  onBlur={() => {
                    const parsed = Number.parseFloat(priceValueStr);
                    const n = Number.isNaN(parsed) ? 0 : parsed;
                    setPriceValue(n);
                    setPriceValueStr(n.toString());
                  }}
                />
              </Field>
              <Field label="Valor remoto">
                <Input
                  type="text"
                  inputMode="decimal"
                  contentAfter={currency}
                  value={remoteFixedValueStr}
                  onFocus={(e) => e.target.select()}
                  onChange={(ev, data) => {
                    setRemoteFixedValueStr(data.value);
                    const parsed = Number.parseFloat(data.value);
                    if (!Number.isNaN(parsed)) setRemoteFixedValue(parsed);
                  }}
                  onBlur={() => {
                    const parsed = Number.parseFloat(remoteFixedValueStr);
                    const n = Number.isNaN(parsed) ? 0 : parsed;
                    setRemoteFixedValue(n);
                    setRemoteFixedValueStr(n.toString());
                  }}
                />
              </Field>
              <Field label="Valor telefónico">
                <Input
                  type="text"
                  inputMode="decimal"
                  contentAfter={currency}
                  value={phoneFixedValueStr}
                  onFocus={(e) => e.target.select()}
                  onChange={(ev, data) => {
                    setPhoneFixedValueStr(data.value);
                    const parsed = Number.parseFloat(data.value);
                    if (!Number.isNaN(parsed)) setPhoneFixedValue(parsed);
                  }}
                  onBlur={() => {
                    const parsed = Number.parseFloat(phoneFixedValueStr);
                    const n = Number.isNaN(parsed) ? 0 : parsed;
                    setPhoneFixedValue(n);
                    setPhoneFixedValueStr(n.toString());
                  }}
                />
              </Field>
            </NestedFields>
          )}
          {valuationTypeOptionSelected && valuationTypeOptionSelected.key === '3' && (
            <NestedFields>
              <Field label={t('conceptForm.formFields.value')}>
                <Input
                  type="text"
                  inputMode="decimal"
                  contentAfter="%"
                  value={percentageValueStr}
                  onFocus={(e) => e.target.select()}
                  onChange={(ev, data) => {
                    setPercentageValueStr(data.value);
                    const parsed = Number.parseFloat(data.value);
                    if (!Number.isNaN(parsed)) setPercentageValue(parsed);
                  }}
                  onBlur={() => {
                    const parsed = Number.parseFloat(percentageValueStr);
                    if (!Number.isNaN(parsed)) {
                      setPercentageValue(parsed);
                      setPercentageValueStr(parsed.toString());
                    }
                  }}
                />
              </Field>
              <Field label={t('conceptForm.formFields.percentageBase')}>
                <RadioGroup
                  value={percentageBase?.toString()}
                  onChange={(ev, data) => {
                    const selectedKey = data.value;
                    const selectedOption = ComponentFunctions.PercentageOriginOptions.find(opt => opt.key === selectedKey);
                    setPercetageBaseOptionSelected(selectedOption);
                    setPercentageBase(Number(selectedKey) || undefined);
                  }}
                >
                  {ComponentFunctions.PercentageOriginOptions.map((option) => (
                    <Radio key={option.key} value={option.key} label={option.text} />
                  ))}
                </RadioGroup>
              </Field>
              {(percetageBaseOptionSelected?.takeFromConcepts) && (
                <>
                  <Label>{t('conceptForm.formFields.percentageConcept')}</Label>
                  <ProtocolConceptMultiSelectorComponent
                    concepts={props.Concepts || []}
                    parentConceptId={props.Concept?.id}
                    showPercentage={false}
                    onAddConcept={onAddConceptToConcept}
                    onDeleteConcept={onRemoveConceptFromConcept}
                    onChangeConceptSelection={onChangeConceptSelection}
                    onChangeApplyOnlyOnOwnerAmount={onChangeApplyOnlyOnOwnerAmount}
                    selectedConceptIds={props.Concepts?.filter(concept => concept.isSelected)?.map(concept => concept.id) || []}
                    applyOnlyOnOwnerAmountConceptIds={applyOnlyOnOwnerAmountConceptIds}
                  />
                  <small>
                    {t('conceptForm.formFields.applyPercentage')}
                  </small>
                </>
              )}
            </NestedFields>
          )}
          {valuationTypeOptionSelected?.key === '2' && (
            <NestedFields>
              <Field label={t('conceptForm.formFields.contractValue')}>
                <Input
                  type="number"
                  contentAfter={currency}
                  defaultValue={maxCostPrice?.toString()}
                  onChange={(ev, data) => {
                    const value = data.value ? Number.parseFloat(data.value) : undefined;
                    setMaxCostPrice(value);
                  }}
                />
              </Field>
              <Text>
                {t('conceptForm.formFields.contractMessage')}
              </Text>
            </NestedFields>
          )}
          {valuationTypeOptionSelected?.key === '4' && !isMedicalService &&
            <GuideMessageBar intent="error">
              <MessageBarBody>{t('conceptForm.formFields.priceMessage')}</MessageBarBody>
            </GuideMessageBar>
          }
          {(valuationTypeOptionSelected?.key === '4' || (valuationTypeOptionSelected?.isPercentage && percetageBaseOptionSelected?.takeFromPriceList)) && isMedicalService && (
            <Field label={t('conceptForm.formFields.priceListOrigin')}>
              <Combobox
                value={priceListOrigin ? ComponentFunctions.PriceListOptions.find(opt => opt.key.toString() === priceListOrigin.toString())?.text || '' : ''}
                selectedOptions={priceListOrigin ? [priceListOrigin.toString()] : []}
                onOptionSelect={(event, data) => {
                  setPriceListOrigin(Number(data.optionValue) || undefined);
                }}
              >
                {ComponentFunctions.PriceListOptions.map((option) => (
                  <Option key={option.key} value={option.key.toString()} text={option.text}>
                    {option.text}
                  </Option>
                ))}
              </Combobox>
            </Field>
          )}
          <ToggleField
            label={t('conceptForm.formFields.ignoreDecimal')}
            description={t('conceptForm.formFields.ignoreDecimalHint')}
            checked={ignoreDecimal}
            onChange={setIgnoreDecimal}
          />
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionWithholding')}
          icon={<ArrowTrendingDownRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.haveWithholding')}
            description={t('conceptForm.formFields.haveWithholdingHint')}
            checked={haveWithdrawal}
            onChange={setHaveWithdrawal}
          >
            <Field label={t('conceptForm.formFields.withholdingPercentage')}>
              <Input
                type="text"
                inputMode="decimal"
                value={withdrawalValueStr}
                contentAfter="%"
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setWithdrawalValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setWithdrawalValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(withdrawalValueStr);
                  if (!Number.isNaN(parsed)) {
                    setWithdrawalValue(parsed);
                    setWithdrawalValueStr(parsed.toString());
                  }
                }}
              />
            </Field>
            <ToggleField
              label={t('conceptForm.formFields.applyWithholdingOnConceptValues')}
              description={t('conceptForm.formFields.applyWithholdingOnConceptValuesHint')}
              checked={applyWithholdingOnConceptValues}
              onChange={setApplyWithholdingOnConceptValues}
            />
          </ToggleField>
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionVisitBehaviour')}
          icon={<CalendarLtrRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.groupWithInTheVisit')}
            checked={groupWithInTheVisit}
            onChange={setGroupWithInTheVisit}
          />
          <ToggleField
            label={t('conceptForm.formFields.isIncludedInVisit')}
            description={t('conceptForm.formFields.isIncludedInVisitHint')}
            checked={isIncludeInVisit}
            onChange={setIsIncludeInVisit}
          >
            <Field label={t('conceptForm.formFields.incluedInContractConceptId')}>
              <ContractConceptSelectorComponent
                ContractId={props.ContractId}
                referralDate={undefined}
                MultiselectEnable={false}
                ContractConceptsSelected={incluedInContractConceptId > 0 ? [incluedInContractConceptId] : []}
                onSelectedContractConcept={(selectedContractConcepts: ContractConcept[]) => {
                  const selectedId = selectedContractConcepts?.[0]?.id;
                  setIncluedInContractConceptId(
                    ComponentFunctions.normalizeIncludedInContractConceptId(selectedId)
                  );
                }}
              />
            </Field>
          </ToggleField>
          {/* Aplica siempre, se liquide o no dentro de otro concepto: por eso va fuera del toggle anterior. */}
          <ToggleField
            label={t('conceptForm.formFields.markIsCostOfConcepyt')}
            description={t('conceptForm.formFields.markIsCostOfConcepytHint')}
            checked={markIsCostOfConcepyt}
            onChange={setMarkIsCostOfConcepyt}
          />
          <ToggleField
            label={t('conceptForm.formFields.isOptional')}
            checked={isOptional}
            onChange={setIsOptional}
          />
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionExecutionMode')}
          description={t('conceptForm.formFields.sectionExecutionModeHint')}
          icon={<VideoRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.applyToInFaceExecution')}
            checked={applyToInFaceExecution}
            onChange={setApplyToInFaceExecution}
          />
          <ToggleField
            label={t('conceptForm.formFields.applyToRemoteExecution')}
            checked={applyToRemoteExecution}
            onChange={setApplyToRemoteExecution}
          />
          <ToggleField
            label={t('conceptForm.formFields.applyToPhoneExecution')}
            checked={applyToPhoneExecution}
            onChange={setApplyToPhoneExecution}
          />
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionProtocolStages')}
          description={t('conceptForm.formFields.sectionProtocolStagesHint')}
          icon={<FlowchartRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.applyToPreScreeningExecution')}
            checked={applyToPreScreeningExecution}
            onChange={setApplyToPreScreeningExecution}
          />
          <ToggleField
            label={t('conceptForm.formFields.applyToScreeningExecution')}
            checked={applyToScreeningExecution}
            onChange={setApplyToScreeningExecution}
          />
          <ToggleField
            label={t('conceptForm.formFields.applyToRandomizationExecution')}
            checked={applyToRandomizationExecution}
            onChange={setApplyToRandomizationExecution}
          />
          <ToggleField
            label={t('conceptForm.formFields.applyToTreatmentExecution')}
            checked={applyToTreatmentExecution}
            onChange={setApplyToTreatmentExecution}
          />
          <ToggleField
            label={t('conceptForm.formFields.applyToFollowUpExecution')}
            checked={applyToFollowUpExecution}
            onChange={setApplyToFollowUpExecution}
          />
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionSpecialVisits')}
          icon={<WarningRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.applyToUnScheduledExecution')}
            checked={applyToUnScheduledExecution}
            onChange={setApplyToUnScheduledExecution}
          />
          <ToggleField
            label={t('conceptForm.formFields.applyToEarlyTerminationExecution')}
            checked={applyToEarlyTerminationExecution}
            onChange={setApplyToEarlyTerminationExecution}
          />
          <ToggleField
            label={'Aplicar a visitas fallidas'}
            checked={applyToFailvisitExecution}
            onChange={setApplyToFailvisitExecution}
          />
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionBranches')}
          icon={<BranchRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.filterByBranches')}
            description={t('conceptForm.formFields.filterByBranchesHint')}
            checked={filterByBranches}
            onChange={setFilterByBranches}
          >
            <ContractBranchSelectorComponent
              ContractId={props.ContractId}
              AddendumId={props.ContractAddendumId}
              onSelectedContractBranch={(selectedBranches: ContractBranch[]) => handleBranchSelection(selectedBranches.map(branch => (

                {
                  id: (branches || []).find((b: ConceptBranch) => b.branchId === branch.id)?.id || 0,
                  contractConceptId: props.ContractConceptId || AddedConceptId || 0,
                  branchId: branch.id,
                  branchName: branch.branchName,
                  branchDescription: branch.branchDescription
                })))}
              ContractBranchesSelected={(branches || []).map(branch => branch.branchId)}
              MultiselectEnable={true}
            />
          </ToggleField>
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionFeesOverhead')}
          icon={<PeopleTeamRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.haveDivisionFee')}
            description={t('conceptForm.formFields.haveDivisionFeeHint')}
            checked={haveDivisionFee}
            onChange={setHaveDivisionFee}
          >
            <Field label={t('conceptForm.formFields.divisionFeeValue')}
              hint={<span>Porcentual institución <strong>{divisionFeeValue}%</strong>&nbsp;-&nbsp;Porcentual Investigador Principal <strong>{100 - divisionFeeValue}%</strong></span>}>
              <Input
                type="text"
                inputMode="decimal"
                contentAfter="%"
                value={divisionFeeValueStr}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setDivisionFeeValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setDivisionFeeValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(divisionFeeValueStr);
                  const n = Number.isNaN(parsed) ? 0 : parsed;
                  setDivisionFeeValue(n);
                  setDivisionFeeValueStr(n.toString());
                }}
              />
            </Field>
          </ToggleField>
          <ToggleField
            label={t('conceptForm.formFields.includedOverhead')}
            description={t('conceptForm.formFields.includedOverheadHint')}
            checked={haveOverhead}
            onChange={setHaveOverhead}
          >
            <Field label={t('conceptForm.formFields.overheadPercentage')}>
              <Input
                type="text"
                inputMode="decimal"
                value={averageOverheadValueStr}
                contentAfter="%"
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setAverageOverheadValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setAverageOverheadValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(averageOverheadValueStr);
                  if (!Number.isNaN(parsed)) {
                    setAverageOverheadValue(parsed);
                    setAverageOverheadValueStr(parsed.toString());
                  }
                }}
              />
            </Field>
          </ToggleField>
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionExtraValues')}
          icon={<AddCircleRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.repeatPrice')}
            description={t('conceptForm.formFields.repeatPriceHint')}
            checked={haveRepetitionPrice}
            onChange={setHaveRepetitionPrice}
          >
            <Field label={t('conceptForm.formFields.additionalValue')}>
              <Input
                type="text"
                inputMode="decimal"
                value={repetitionPriceValueStr}
                contentAfter={currency}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setRepetitionPriceValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setRepetitionPriceValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(repetitionPriceValueStr);
                  if (!Number.isNaN(parsed)) {
                    setRepetitionPriceValue(parsed);
                    setRepetitionPriceValueStr(parsed.toString());
                  }
                }}
              />
            </Field>
          </ToggleField>
          <ToggleField
            label={t('conceptForm.formFields.earlyDiscontinuationPrice')}
            description={t('conceptForm.formFields.earlyDiscontinuationPriceHint')}
            checked={haveEarlyDiscontinuationPrice}
            onChange={setHaveEarlyDiscontinuationPrice}
          >
            <Field label={t('conceptForm.formFields.earlyDiscontinuationValue')}>
              <Input
                type="text"
                inputMode="decimal"
                value={earlyDiscontinuationPriceStr}
                contentAfter={currency}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setEarlyDiscontinuationPriceStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setEarlyDiscontinuationPrice(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(earlyDiscontinuationPriceStr);
                  if (!Number.isNaN(parsed)) {
                    setEarlyDiscontinuationPrice(parsed);
                    setEarlyDiscontinuationPriceStr(parsed.toString());
                  }
                }}
              />
            </Field>
          </ToggleField>
          <ToggleField
            label={t('conceptForm.formFields.haveRetroaactivity')}
            description={t('conceptForm.formFields.haveRetroaactivityHint')}
            checked={haveRetroactivity}
            onChange={setHaveRetroactivity}
          >
            <DateTimeInput
              label={t('conceptForm.formFields.retroactivityDateFrom')}
              placeHolder={'ingrese una fecha'}
              selectedDate={retroactivityDateFrom ? new Date(retroactivityDateFrom) : new Date()}
              isSubmitted={false}
              isRequired={settlementSetting === 5}
              errorMessage={undefined}
              onSelectDate={(date: Date | null | undefined) => setRetroactivityDateFrom(date)}
            />
          </ToggleField>
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.applicationCriteria')}
          icon={<PersonRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.appliesToMen')}
            checked={appliesToMen}
            onChange={setAppliesToMen}
          />
          <ToggleField
            label={t('conceptForm.formFields.appliestoWomen')}
            checked={appliesToWomen}
            onChange={setAppliesToWomen}
          >
            <ToggleField
              label={t('conceptForm.formFields.womenFertileAge')}
              checked={appliesToWomenOfFertileAge}
              onChange={setAppliesToWomenOfFertileAge}
            />
            <ToggleField
              label={t('conceptForm.formFields.womenOfNonFertileAge')}
              checked={appliesToWomenOfNonFertileAge}
              onChange={setAppliesToWomenOfNonFertileAge}
            />
          </ToggleField>
          <ToggleField
            label={t('conceptForm.formFields.applieBetweenAges')}
            checked={appliesBetweenAges}
            onChange={setAppliesBetweenAges}
          >
            <Field label={t('conceptForm.formFields.ageRangefrom')}>
              <Input
                type="number"
                value={appliesAgesFrom?.toString()}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => setAppliesAgesFrom(Number(data.value))}
              />
            </Field>
            <Field label={t('conceptForm.formFields.ageRangeto')}>
              <Input
                type="number"
                value={appliesAgesTo?.toString()}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => setAppliesAgesTo(Number(data.value))}
              />
            </Field>
          </ToggleField>
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionQuantityCalculation')}
          icon={<CalculatorRegular fontSize={18} />}
        >
          <Field label={t('conceptForm.formFields.quantityToSettle')}>
            <Input
              type="number"
              contentAfter='Cantidad'
              value={quantityToSettle?.toString()}
              onFocus={(e) => e.target.select()}
              onChange={(ev, data) => setQuantityToSettle(Number(data.value))}
            />
          </Field>
          <Field label={t('conceptForm.formFields.calculateType')}>
            <Combobox
              value={calculateType ? t(ComponentFunctions.calculateTypeOptions.find(opt => opt.key.toString() === calculateType.toString())?.text || '') : ''}
              selectedOptions={calculateType ? [calculateType.toString()] : []}
              onOptionSelect={(event, data) => {
                setCalculateType(Number(data.optionValue) || undefined);
              }}
            >
              {ComponentFunctions.calculateTypeOptions.map((option) => (
                <Option key={option.key} value={option.key.toString()} text={t(option.text) || ''}>
                  {t(option.text)}
                </Option>
              ))}
            </Combobox>
          </Field>
          <ToggleField
            label={t('conceptForm.formFields.needAgrupation')}
            description={t('conceptForm.formFields.needAgrupationHint')}
            checked={needAggrupation}
            onChange={setNeedAggrupation}
          >
            <Field label={t('conceptForm.formFields.agroupationSegment')}>
              <Input
                type="number"
                contentAfter={t(ComponentFunctions.getCalculateTypeDescription(calculateType))}
                value={aggrupationSegment?.toString()}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => setAggrupationSegment(Number(data.value))}
              />
            </Field>
          </ToggleField>
          <ToggleField
            label={t('conceptForm.formFields.excludeParticularPatient')}
            description={t('conceptForm.formFields.excludeParticularPatientHint')}
            checked={excludeParticularPatient}
            onChange={setExcludeParticularPatient}
          />
        </FormSection>

        <FormSection
          title={t('conceptForm.formFields.sectionCosts')}
          icon={<WalletRegular fontSize={18} />}
        >
          <ToggleField
            label={t('conceptForm.formFields.haveCost')}
            description={t('conceptForm.formFields.haveCostHint')}
            checked={haveCost}
            onChange={setHaveCost}
          >
            <Field label={t('conceptForm.formFields.conceptCost')}>
              <Combobox
                value={costSettingOptionSelected ? costSettingOptionSelected.text : ''}
                selectedOptions={costSetting ? [costSetting.toString()] : []}
                onOptionSelect={(event, data) => {
                  const selectedKey = data.optionValue;
                  const selectedOption = ComponentFunctions.ConceptCostOptions.find(opt => opt.key.toString() === selectedKey);
                  setCostSettingOptionSelected(selectedOption);
                  setCostSetting(Number(selectedKey) || undefined);
                }}
              >
                {ComponentFunctions.ConceptCostOptions.map((option) => (
                  <Option key={option.key} value={option.key.toString()} text={option.text}>
                    {option.text}
                  </Option>
                ))}
              </Combobox>
            </Field>
            {costSettingOptionSelected?.isFixedPrice && (
              <Field label={t('conceptForm.formFields.costValue')}>
                <Input
                  type="text"
                  inputMode="decimal"
                  value={fixedCostValueStr}
                  contentAfter={currency}
                  onFocus={(e) => e.target.select()}
                  onChange={(ev, data) => {
                    setFixedCostValueStr(data.value);
                    const parsed = Number.parseFloat(data.value);
                    if (!Number.isNaN(parsed)) setFixedCostValue(parsed);
                  }}
                  onBlur={() => {
                    const parsed = Number.parseFloat(fixedCostValueStr);
                    if (!Number.isNaN(parsed)) {
                      setFixedCostValue(parsed);
                      setFixedCostValueStr(parsed.toString());
                    }
                  }}
                />
              </Field>
            )}
            {costSettingOptionSelected?.isPercentage && (
              <Field label={t('conceptForm.formFields.costValue')}>
                <Input
                  type="text"
                  inputMode="decimal"
                  value={fixedCostValueStr}
                  contentAfter='%'
                  onFocus={(e) => e.target.select()}
                  onChange={(ev, data) => {
                    setFixedCostValueStr(data.value);
                    const parsed = Number.parseFloat(data.value);
                    if (!Number.isNaN(parsed)) setFixedCostValue(parsed);
                  }}
                  onBlur={() => {
                    const parsed = Number.parseFloat(fixedCostValueStr);
                    if (!Number.isNaN(parsed)) {
                      setFixedCostValue(parsed);
                      setFixedCostValueStr(parsed.toString());
                    }
                  }}
                />
              </Field>
            )}
            {costSettingOptionSelected?.isPriceList && !isMedicalService &&
              <GuideMessageBar intent="error">
                <MessageBarBody>{t('conceptForm.formFields.priceMessage')}</MessageBarBody>
              </GuideMessageBar>
            }
            {costSettingOptionSelected?.isPriceList && isMedicalService && (
              <Field label={t('conceptForm.formFields.selectPriceList')}>
                <Combobox
                  value={costPriceListOrigin ? ComponentFunctions.OriginConceptCostOptions.find(opt => opt.key.toString() === costPriceListOrigin.toString())?.text || '' : ''}
                  selectedOptions={costPriceListOrigin ? [costPriceListOrigin.toString()] : []}
                  onOptionSelect={(event, data) => {
                    setCostPriceListOrigin(Number(data.optionValue) || undefined);
                  }}
                >
                  {ComponentFunctions.OriginConceptCostOptions.map((option) => (
                    <Option key={option.key} value={option.key.toString()} text={option.text}>
                      {option.text}
                    </Option>
                  ))}
                </Combobox>
              </Field>
            )}
            {costSettingOptionSelected?.isPriceList && costPriceListOrigin === 2 && isMedicalService && (
              <>
                <Label>{t('conceptForm.formFields.provider')}</Label>
                <ProviderSelectorComponent MultiselectEnable={false} ProviderSelected={[]} />
              </>
            )}
            {costSettingOptionSelected?.isTakeFromServices && (
              <ServiceCategorySelectorComponent
                onSelectedServiceCategory={(categories: ServiceCategory[]) => {
                  console.log('ServiceCategory selected:', categories);
                  // Extraer los IDs (strings) de las categorías seleccionadas
                  const categoryIds = categories.map(cat => cat.id);
                  setServiceCategory(categoryIds);
                }}
                ServiceCategoriesSelected={serviceCategory}
                MultiselectEnable={false}
                showLabel={true}
                showManageButton={true}
              />
            )}
          </ToggleField>
        </FormSection>
      </div>
      {(settlementSettingOptionSelected?.key === '4' || valuationTypeOptionSelected?.key === '5') && (
        <div
          ref={rightScroll.ref}
          className={`flowcharContainer ScrollShadow${rightScroll.showTop ? ' shadow-top' : ''}${rightScroll.showBottom ? ' shadow-bottom' : ''}`}
          onScroll={rightScroll.onScroll}
        >
          {/* <Label>{t('conceptForm.formFields.flowChart')}</Label> */}
          <div className="FlowChart">
            <ContractStageMultiSelectorComponent
              ContractId={props.ContractId}
              ContractAddendumId={props.ContractAddendumId}
              ContractConceptId={props.ContractConceptId || AddedConceptId}
              ShowInputValues={valuationTypeOptionSelected?.key === '5' ? true : false}
              ConceptSaved={ContractConceptSaved}
              currency={currency}
              applyToRemoteExecution={applyToRemoteExecution}
              applyToInFaceExecution={applyToInFaceExecution}
              applyToPhoneExecution={applyToPhoneExecution}
              applyToFailvisitExecution={applyToFailvisitExecution}
              applyToFollowUpExecution={applyToFollowUpExecution}
              OnAllSaved={onFinishedSavingHandler}

            />
          </div>
        </div>
      )}
    </div>
  );

  // form validation

  const ValidateForm = (): boolean => {
    let validationResult: boolean = true;

    let FormValidation: FormValidation = { success: true, errors: [] };
    setFormValidationStatus(FormValidation);

    const normalizedIncludedConceptId = ComponentFunctions.normalizeIncludedInContractConceptId(incluedInContractConceptId);
    if (isIncludeInVisit && normalizedIncludedConceptId === 0) {
      validationResult = false;
      FormValidation.errors.push(t('conceptForm.formFields.includedConceptRequiredError'));
    }

    FormValidation.success = validationResult;
    setFormValidationStatus({ ...FormValidation });
    return validationResult;
  };

  // Con el diagrama de etapas a la derecha el formulario necesita todo el ancho (antes 80vw).
  const showsStageEditor = settlementSettingOptionSelected?.key === '4' || valuationTypeOptionSelected?.key === '5';
  const isSaving = !!(props.isAdding || props.isUpdating || savingSchedules);

  return (
    <GuideDrawer
      open={props.isOpen}
      size={showsStageEditor ? 'full' : 'medium'}
      onDismiss={HandleCancelForm}
      className={props.Concept?.contractConceptApproved === true ? 'ConceptFormDrawer Approved' : 'ConceptFormDrawer'}
      testId="concept-form-drawer"
      eyebrow={props.Concept?.concept?.conceptName || undefined}
      title={
        <>
          {t('conceptForm.panel.visitInformation')}
          {props.Concept?.contractConceptEnabled === false && (
            <span className='ConceptFormDisabledTag'>{t('conceptItem.flags.disabled')}</span>
          )}
        </>
      }
      headerActions={
        /* Approval is a review decision on a saved concept, so it is not
           offered until the concept exists, and it saves on its own
           endpoint rather than riding along with the form. */
        props.ContractConceptId ? (
          <Switch
            className='ConceptFormApprovedSwitch'
            labelPosition='before'
            label={t('conceptItem.flags.approved')}
            checked={props.Concept?.contractConceptApproved === true}
            onChange={(ev, data) =>
              props.SetContractConceptApproved(
                props.ContractConceptId!,
                data.checked,
                props.ContractId,
                props.ContractAddendumId
              )}
          />
        ) : undefined
      }
      secondaryAction={{
        label: <Trans i18nKey={'conceptForm.footer.cancelButton'} />,
        onClick: HandleCancelForm
      }}
      primaryAction={{
        label: props.isAdding || props.isUpdating ? <Trans i18nKey={'conceptForm.footer.saving'} /> : <Trans i18nKey={'conceptForm.footer.saveButton'} />,
        onClick: HandleSaveForm,
        loading: isSaving
      }}
    >
      {submittedForm && !FormValidationStatus?.success && (
        <GuideMessageBar intent="error" className='conceptFormErrorBar conceptFormValidationErrorBar'>
          <MessageBarBody>
            <MessageBarTitle>{t('conceptForm.panel.reviewInformation')}</MessageBarTitle>
            <ul className='conceptFormErrorList'>
              {FormValidationStatus?.errors.map(
                (Error: string, index: number) => (
                  <li key={index}>{Error}</li>
                )
              )}
            </ul>
          </MessageBarBody>
        </GuideMessageBar>
      )}
      {(props.failOnAdding || props.failOnUpdating) &&
        props.error && (
          <GuideMessageBar intent="error" className='conceptFormErrorBar conceptFormSaveErrorBar'>
            <MessageBarBody>
              <MessageBarTitle>{t('conceptForm.panel.saveErrorTitle')}</MessageBarTitle>
              <Text className='conceptFormSaveErrorText'>{props.error.ErrorMessage}</Text>
            </MessageBarBody>
          </GuideMessageBar>
        )}
      {formFields}
    </GuideDrawer>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(ConceptFormComponent as any);
